import styled, { css } from 'styled-components';
import { header6, header1 } from '@westwing/ui-kit/typography';
import { forTablet, forDesktop, forWideScreens } from '@westwing/ui-kit/breakPoints';
import Text from '@ids/components/Typography/Text';
import Heading from '@ids/components/Typography/Heading';
import GenericMedia from '@ids/components/Media';
import Center from '@ids/components/Layout/Center';

const bannerMarginTop = {
    TABLET: '-100px',
    DESKTOP: '-120px',
};

export const HeroSection = styled.section`
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    ${forTablet`
        display: grid;
        min-height: initial;
        grid-template-areas:
            'media media media'
            '. banner .'
            '. subtitle .';
        grid-template-columns: minmax(auto, 80px) 1fr minmax(auto, 80px);
        grid-template-rows: 570px minmax(calc(250px + ${bannerMarginTop.TABLET}), auto) minmax(85px, auto)
    `}

    ${forDesktop`
        grid-template-columns: minmax(auto, 150px) 1fr minmax(auto, 150px);
        grid-template-rows: 570px minmax(calc(250px + ${bannerMarginTop.DESKTOP}), auto) minmax(85px, auto)
    `}

    ${forWideScreens`
        grid-template-columns: minmax(auto, 230px) 1fr minmax(auto, 230px);
    `}
`;

export const Media = styled(GenericMedia)<{ $mobileOnly?: boolean; $desktopOnly?: boolean }>`
    width: 100%;
    position: relative;
    margin-bottom: 30px;
    background: ${({ theme }) => theme.colors.skeleton01};
    color: ${({ theme }) => theme.colors.skeleton01};

    &[data-type='video'] {
        aspect-ratio: 4/3;

        @supports not (aspect-ratio: 1/1) {
            height: 100%;
        }
    }

    &[data-type='image'] {
        min-height: 350px;
    }

    ${forTablet`
        &[data-type='video'] {
            aspect-ratio: initial;
            height: initial;
            padding-bottom: initial;
        }

        grid-area: media;
        margin-bottom: initial;
    `}

    ${({ $desktopOnly, $mobileOnly }) => {
        if (!$desktopOnly && !$mobileOnly) {
            return css``;
        }
        if ($desktopOnly) {
            return css`
                display: none;
                ${forDesktop`display: block;`}
            `;
        }
        if ($mobileOnly) {
            return css`
                display: block;
                ${forDesktop`display: none;`}
            `;
        }
        return css``;
    }}
`;

export const Banner = styled(Center.Vertical)`
    background-color: #fff;
    width: 100%;
    padding: 20px;

    ${forTablet`
        padding: 25px 2em 35px;
        grid-area: banner;
        z-index: 10;
        margin: ${bannerMarginTop.TABLET} 0 25px;
    `}

    ${forDesktop`
        margin: ${bannerMarginTop.DESKTOP} 0 25px;
    `}
`;

export const HeadlineText = styled(Heading)`
    ${({ hidden }) =>
        hidden &&
        css`
            display: none;
        `}
    margin-bottom: 20px;

    ${forTablet`
        margin-bottom: 15px;
    `}

    ${header6}
`;

export const Title = styled(Heading)`
    margin-bottom: 10px;
`;

export const SubtitleText = styled(Text)`
    text-align: center;
    padding: 0 20px;
    line-height: 40px;

    ${forTablet`
        grid-area: subtitle;
        padding: 0 30px;
        max-width: 900px;
        margin: 0 auto;
    `}

    ${header1}
`;
